"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsiblePanelContextProvider = CollapsiblePanelContextProvider;
exports.useCollapsiblePanelContext = useCollapsiblePanelContext;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CollapsiblePanelContext = /*#__PURE__*/(0, _react.createContext)();

function useCollapsiblePanelContext() {
  var context = (0, _react.useContext)(CollapsiblePanelContext);

  if (!context) {
    throw new Error('useCollapsiblePanelContext must be used within a CollapsiblePanelContextProvider. Wrap a parent component in <CollapsiblePanelContextProvider> to fix this error');
  }

  return context;
}

function CollapsiblePanelContextProvider(props) {
  var children = props.children,
      isCollapsed = props.isCollapsed,
      onCollapse = props.onCollapse;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    _react["default"].createElement(CollapsiblePanelContext.Provider, {
      value: {
        isCollapsed: isCollapsed,
        onCollapse: onCollapse
      }
    }, children)
  );
}

CollapsiblePanelContextProvider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  isCollapsed: _propTypes["default"].bool.isRequired,
  onCollapse: _propTypes["default"].func.isRequired
};